import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLandingT } from "@/lib/landingI18n";
import { LANDING } from "@/constants/landingTestIds";

const faqs = [
  { key: "faq1" },
  { key: "faq2" },
  { key: "faq3" },
  { key: "faq4" },
];

export const FaqSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section id="faq" className="relative py-20 md:py-28 border-t border-white/8">
      <div className="max-w-[900px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="kicker">
            <span className="dot" />
            {t("faqKicker")}
          </div>
          <h2 className="h-section mt-5 text-white">{t("faqTitle")}</h2>
        </div>

        <div className="mt-10 glass rounded-2xl px-6 md:px-8 py-2">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.key}
                value={f.key}
                className="border-white/8"
                data-testid={`${LANDING.faqItem}-${i}`}
              >
                <AccordionTrigger className="text-start text-white hover:no-underline text-base md:text-lg font-medium py-6">
                  {t(`${f.key}Q`)}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-sm md:text-base leading-relaxed pb-6">
                  {t(`${f.key}A`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
